/*
 * @Author: liuzhongyu
 * @Date: 2023-02-14 14:47:31
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-03-01 14:43:17
 */

import React, { useState, useEffect } from 'react';
import SupTable from 'sup-rc-table';
import styles from './index.less';
import Modal from 'root/components/CommonModal';
import { useIntl } from 'react-intl';
import messages from './messages';

interface PropsType {
  visible: boolean;
  onOk: (e: any) => void;
  onCancel: (e: any) => void;
  data: any;
}

const RealTimeLog = (props: PropsType) => {
  const { visible, onOk, onCancel, data } = props;
  const intl = useIntl();

  const [columns, setColumns] = useState<any[]>([]); // 表头数据

  const jumpLog = (text: string, record: any) => {
    sessionStorage.setItem('serviceLog', JSON.stringify({ [text]: record.containers }));
    window.open(`#/serviceLog/${text}`, '_blank');
  };

  useEffect(() => {
    setColumns([
      {
        title: intl.formatMessage(messages.host),
        dataIndex: 'hostIP',
        key: 'hostIP',
        sorter: true,
        align: 'left',
      },
      {
        title: intl.formatMessage(messages.instanceName),
        dataIndex: 'podName',
        key: 'podName',
        sorter: true,
        align: 'left',
      },
      {
        title: intl.formatMessage(messages.runStatus),
        dataIndex: 'status',
        key: 'status',
        sorter: true,
        align: 'left',
      },
      {
        title: intl.formatMessage(messages.operate),
        align: 'center',
        dataIndex: 'podName',
        key: 'podName',
        render: (text: string, record: any) => {
          return (
            <div>
              <a
                className={styles.linkBtn}
                target="_blank"
                onClick={() => {
                  jumpLog(text, record);
                }}
              >
                {intl.formatMessage(messages.view)}
              </a>
            </div>
          );
        },
      },
    ]);
  }, [data]);

  return (
    <Modal
      title={`${data?.name || ''} ${intl.formatMessage(messages.selectHostNode)} `}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      className={styles.modal}
      width={1000}
    >
      <div className={styles.wrapper}>
        <div className={styles.dataTable}>
          <SupTable
            controlColumns
            rowKey={(record: any) => record}
            showSearchIcon={false}
            showColumnsFilter={false}
            showSelection={false}
            columns={columns}
            dataSource={data || []}
            className={styles.dataTable}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RealTimeLog;
